// src/components/common/Footer.js
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../../contexts/LanguageContext';

const Footer = () => {
  const { lang } = useContext(LanguageContext);

  const translations = {
    ja: {
      company: '運営会社',
      contact: 'お問合せ',
      privacy: '情報保護方針',
      service: 'サービス',
      copyright: '© 2025 HiveMinds LLC. All rights reserved.'
    },
    en: {
      company: 'Company',
      contact: 'Contact',
      privacy: 'Privacy Policy',
      service: 'Service',
      copyright: '© 2025 HiveMinds LLC. All rights reserved.'
    }
  };

  const t = translations[lang] || translations.ja;

  const footerLinks = [
    { label: t.company, href: 'https://hiveminds.co.jp', key: 'company' },
    { label: t.contact, href: 'https://hiveminds.co.jp/contact', key: 'contact' },
    { label: t.privacy, href: '/privacy-policy', key: 'privacy' },
    { label: t.service, href: '/shindan', key: 'service' }
  ];

  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="w-full max-w-7xl mx-auto">
        <div className="px-5 py-10">
          <div className="flex flex-col gap-6">
            {/* Footer Links */}
            <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-8">
              {footerLinks.map((link) => (
                <div 
                  key={link.key}
                  className="min-w-[160px] flex flex-col justify-start items-center"
                >
                  <Link 
                    to={link.href}
                    className="text-center text-slate-600 text-base font-normal leading-6 hover:text-blue-600 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </div>
              ))}
            </div>
            
            {/* Copyright */}
            <div className="flex flex-col justify-start items-center">
              <div className="text-center text-slate-600 text-base font-normal leading-6">
                {t.copyright}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;